import React, { useEffect, useRef, useState } from "react";

function PDFViewer({ pdfUrl, buttonText = "VER DOCUMENTO" }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dialogRef = useRef(null);

  useEffect(() => {
    if (!isModalOpen) return;
    const dialog = dialogRef.current;
    const previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = "hidden";
    return () => {
      dialog.close();
      document.body.style.overflow = previousOverflow;
    };
  }, [isModalOpen]);

  return (
    <>
      <button type="button" onClick={() => setIsModalOpen(true)}
        className="bg-[#31BBE4] text-[#18333B] px-5 py-3 mt-4 sm:mt-8 rounded-xl font-gotham font-medium hover:bg-[#67CEEB] transition-colors">
        {buttonText}
      </button>
      <dialog ref={dialogRef} aria-labelledby="quality-title" className="quality-dialog rounded-2xl p-0 bg-white text-[#3A3A3C]"
        onCancel={() => setIsModalOpen(false)} onClick={event => { if (event.target === event.currentTarget) setIsModalOpen(false); }}>
        {isModalOpen && <div className="flex flex-col h-full">
          <div className="flex flex-wrap justify-between items-center gap-3 p-4 border-b">
            <h2 id="quality-title" className="text-lg font-gotham font-bold">Políticas de calidad</h2>
            <div className="flex gap-2">
              <a href={pdfUrl} download="politicas_de_calidad.pdf" className="bg-[#3A3A3C] text-white px-4 py-3 rounded-lg text-sm hover:bg-[#565659]">Descargar</a>
              <button type="button" autoFocus onClick={() => setIsModalOpen(false)} className="border border-gray-300 px-4 py-3 rounded-lg text-sm hover:bg-gray-100">Cerrar</button>
            </div>
          </div>
          <div className="flex-1 min-h-0 p-3">
            <iframe src={pdfUrl} className="w-full h-full rounded-lg border" title="Políticas de calidad de Entrecor" />
          </div>
        </div>}
      </dialog>
    </>
  );
}

export default PDFViewer;
